'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const jsxRuntime = require('react/jsx-runtime');
const clsx = require('clsx');
const React = require('react');
const theme_Colors = require('../../../theme/Colors.cjs.js');
require('../../../theme/Shadows.cjs.js');
require('../../../theme/Typography.cjs.js');
const components_display_Icon_compiled_index = require('../../../index-BmYOrUsf.js');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const clsx__default = /*#__PURE__*/_interopDefault(clsx);

const root = "_root_1w0hf_1";
const styles = {
	root: root
};

const MissingIcon = () => jsxRuntime.jsx("svg", { "aria-label": "Could not load icon", "data-is-missing-icon": "true", viewBox: "0 0 24 24", children: jsxRuntime.jsx("rect", { height: "24", width: "24", x: "0", y: "0" }) });
class IconErrorBoundary extends React.Component {
  constructor() {
    super(...arguments);
    this.state = {
      didFailToLoad: false
    };
  }
  static getDerivedStateFromError() {
    return {
      didFailToLoad: true
    };
  }
  render() {
    return this.state.didFailToLoad ? jsxRuntime.jsx(MissingIcon, {}) : this.props.children;
  }
}
function getCssSize(size) {
  if (size === "small" || size === void 0) {
    return "24px";
  }
  if (size === "medium") {
    return "36px";
  }
  if (size === "large") {
    return "48px";
  }
  return size;
}
const Icon = ({ "aria-label": ariaLabel, color, isBlock = false, name, "aria-hidden": ariaHidden = true, canAcceptPointerEvents = true, shouldAnimateFill = true, size = "small", className }) => {
  const IconComponent = getIcon(name);
  const cssSize = getCssSize(size);
  return jsxRuntime.jsx("span", { "aria-hidden": ariaHidden ? "true" : void 0, "aria-label": ariaLabel, className: clsx__default.default(styles.root, `zds-deprecated-icon-${name}`, className), "data-testid": "iconContainer", "data-zds": true, "data-block": isBlock, "data-pointer-events": canAcceptPointerEvents, "data-animate": shouldAnimateFill, style: {
    "--_zds-icon-height": cssSize,
    "--_zds-icon-width": cssSize,
    "--_zds-icon-fill": color ? theme_Colors.Colors[color] : "currentColor"
  }, children: jsxRuntime.jsx(IconErrorBoundary, { children: jsxRuntime.jsx(IconComponent, { size: cssSize, color, name }) }) });
};
const nameMap = (/* @__PURE__ */ new Map()).set("actionAIText", "ActionAiText").set("actionAIFix", "ActionAiFix").set("miscAI", "MiscAi").set("miscAI", "MiscAi").set("miscAIFill", "MiscAiFill").set("navAIChatbot", "NavAiChatbot").set("miscEvergreenAI", "MiscEvergreenAi").set("miscMCP", "MiscMcp").set("navMCP", "NavMcp");
function capitalize(string) {
  return string[0].toUpperCase() + string.slice(1);
}
function getIcon(name) {
  try {
    const realName = nameMap.get(name);
    if (realName) {
      return components_display_Icon_compiled_index.Icons[realName] || MissingIcon;
    }
    const capitalizedIcon = capitalize(name);
    return components_display_Icon_compiled_index.Icons[capitalizedIcon] || MissingIcon;
  } catch (_a) {
    return MissingIcon;
  }
}

exports.Icon = Icon;
//# sourceMappingURL=Icon.cjs.js.map
